import { injectable } from 'inversify';
import { DevOptions } from './config.dev';
import { ProdOptions } from './config.prod';
import { IAppConfig, IBaseConfiguration, IConfiguration } from './config.types';

@injectable()
export class Configuration implements IConfiguration {
  version: string;
  baseUrl: string;
  hubUrl: string;
  projectHubUrl: string;
  uploadsHubUrl: string;
  appConfig!: IAppConfig;

  constructor() {
    const configuration: IBaseConfiguration = process.env.NODE_ENV === 'development' ? DevOptions : ProdOptions;

    this.version = configuration.version;
    this.baseUrl = configuration.baseUrl;
    this.hubUrl = configuration.hubUrl;
    this.projectHubUrl = configuration.projectHubUrl;
    this.uploadsHubUrl = configuration.uploadsHubUrl;
  }

  setupAppConfig(appConfig: IAppConfig): void {
    this.appConfig = appConfig;
  }
}
